/* AF — Keep collection hero bg video playing
   Prevent Dawn's global.js pauseAllMedia() from pausing .af-collection-bg-video
*/
(function () {
  const HERO_SEL = '.af-collection-bg-video';

  // Patch pause() so hero video ignores pause calls (from pauseAllMedia)
  if (!HTMLMediaElement.prototype.__afHeroPausePatched) {
    const origPause = HTMLMediaElement.prototype.pause;

    HTMLMediaElement.prototype.pause = function (...args) {
      try {
        if (this && this.matches && this.matches(HERO_SEL)) {
          // ignore pause() for the hero background video
          return;
        }
      } catch (e) {}
      return origPause.apply(this, args);
    };

    HTMLMediaElement.prototype.__afHeroPausePatched = true;
  }

  // Also force-resume if anything pauses it (extra safety)
  function safePlay(v) {
    if (!v) return;
    try {
      v.muted = true;
      v.setAttribute('muted', '');
      v.setAttribute('playsinline', '');
      const p = v.play();
      if (p && p.catch) p.catch(() => {});
    } catch (e) {}
  }

  function init() {
    const v = document.querySelector(HERO_SEL);
    if (!v || v.__afKeepPlaying) return;
    v.__afKeepPlaying = true;

    v.addEventListener('pause', () => setTimeout(() => safePlay(v), 0));
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') safePlay(v);
    });

    safePlay(v);
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
